import React from 'react';

class UpdatePaymentSuccess extends React.Component {
  render() {
    return (
      <div className='update-card-container flex-column'>
        <div className='full-scene flex-column'>
          <img
            src={require('../../images/confirmationCheckmark.png')}
            className='confirmation-checkmark-lrg'
          />
          <div className='status-text'>
            Payment Method Successfully Updated
          </div>
        </div>
      </div>
    );
  }
}

module.exports = UpdatePaymentSuccess;


// WEBPACK FOOTER //
// ./src/components/payments/UpdatePaymentSuccess.js